import React, {
  forwardRef,
} from 'react';

import PhoneInput, {
  PhoneInputProps,
} from 'react-phone-number-input';
import flags from 'react-phone-number-input/flags';

import { Box } from '@waglabs/box-next';
import {
  TextField,
  Props as TextFieldProps,
} from '@waglabs/textfield';
import { Typography } from '@waglabs/typography';

import { PhoneTextFieldGlobalStyle } from './PhoneTextFieldGlobalStyle';

export type PhoneTextFieldProps = Omit<PhoneInputProps, 'ref'> & Omit<TextFieldProps, 'ref' | 'onChange'>;

const PhoneInputComponent = forwardRef((props, ref) => (
  <TextField
    variant="filled"
    {...props}
    inputProps={{
      fontFamily: 'muli',
    }}
    ref={ref}
  />
));

export const PhoneTextField = ({
  helperText,
  helperTextProps,
  error,
  ...rest
}: PhoneTextFieldProps) => (
  <Box
    width={1}
  >
    <PhoneTextFieldGlobalStyle
      error={error}
    />
    <PhoneInput
      international={false}
      flags={flags}
      inputComponent={PhoneInputComponent}
      defaultCountry="US"
      countrySelectProps={{
        disabled: true,
      }}
      showCountrySelect
      {...rest}
    />
    {/*
      Re-implementing the helper text + error outside the Textfield
      to properly displayed since PhoneInput is from a library
      that have different tree structure
      */}
    {helperText && (
      <Typography
        variant="legal"
        color={error ? 'red' : 'initial'}
        {...helperTextProps}
      >
        {helperText}
      </Typography>
    )}
  </Box>
);
